import script from "./GenerateOcurrence.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateOcurrence.vue?vue&type=script&setup=true&lang=js"

import "./GenerateOcurrence.vue?vue&type=style&index=0&id=17547d7e&lang=scss"

const __exports__ = script;

export default __exports__
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanels,QPageContainer,QPage,QOptionGroup,QTabPanel});
